var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.INCOMPLETE_DATA = {
    NONE: 'NONE',
    MY_DATA_ONLY: 'MY_DATA_ONLY',
    ALL: 'ALL'
};

Object.freeze(Enum.MEEDY.INCOMPLETE_DATA);